import * as AuthProxy from "../../security/AuthProxy";

export function getTenantIds()
{
    return fetch(`./pharmacy/portunus/tenantId`,{
        headers: {
            'session-id': AuthProxy.getSessionId() as string,
            'authtype': AuthProxy.getAuthType() as string
        }
    });
}
